export default "__VITE_PUBLIC_ASSET__788af8d6__"